import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";

export type { CheckboxProps };

export default Checkbox;
